import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-basic_management",
  "use": "icon-basic_management-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-basic_management\"><defs><style type=\"text/css\"></style></defs><path d=\"M888.9 916.2H135.1c-38.6 0-70-31.4-70-70V177.8c0-38.6 31.4-70 70-70H889c38.6 0 70 31.4 70 70v668.5c-0.1 38.5-31.5 69.9-70.1 69.9zM135.1 147.8c-16.5 0-30 13.5-30 30v668.5c0 16.5 13.5 30 30 30H889c16.5 0 30-13.5 30-30V177.8c0-16.5-13.5-30-30-30H135.1z\" p-id=\"2496\" /><path d=\"M242 379.3h540v40H242z\" p-id=\"2497\" /><path d=\"M689.334 331.333v136h-40v-136z\" p-id=\"2498\" /><path d=\"M782 644.634H242v-40h540z\" p-id=\"2499\" /><path d=\"M334.732 692.666v-136h40v136z\" p-id=\"2500\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/basic_management.svg
// module id = dfvW
// module chunks = 45